import { Component, Inject, Optional, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Field } from 'simpo-component-library/lib/sections/contact-us/contact-us.modal';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { INPUT_FIELDS_TYPE } from 'simpo-component-library';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CrmServiceService } from 'src/app/master-config-components/micro-apps/crm/service/crm-service.service';
import { FormControl, Validators } from '@angular/forms';
import { CreateFieldGroupComponent } from 'src/app/master-config-components/micro-apps/crm/crm-config/template/create-field-group/create-field-group.component';
import { DbService } from 'src/app/services/db-service/db.service';
import { duration } from 'moment';
interface FIELD_INFO {
  icon: string,
  text: string,
  description: string,
  customIcon: boolean,
  iconTxt: string | null,
  type: INPUT_FIELDS_TYPE
}

@Component({
  selector: 'app-add-contact-fields',
  templateUrl: './add-contact-fields.component.html',
  styleUrls: ['./add-contact-fields.component.scss'],
})
export class AddContactFieldsComponent {
  constructor(
    public dialogRef: MatDialogRef<AddContactFieldsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public bottomSheetRef: MatBottomSheetRef<AddContactFieldsComponent>,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomData: any,
    private crmService: CrmServiceService,
    private dbService: DbService,
    public dialog: MatDialog
  ) {
    this.getFieldGroupList();
    this.getDataSourceTypesApi();
    this.getScreenSize();
    this.checkLimits()
    this.getAllFieldTypes();
  }

  showWarning = false;
  fieldCategory: any;

  checkLimits() {
    if (this.payload.minLimit > 0) {
      this.showWarning = this.payload.minLimit !== null && this.payload.maxLimit !== null && this.payload.minLimit >= this.payload.maxLimit;
    }
  }

  fieldTypeList: any[] = [];
  getAllFieldTypes() {
    this.crmService.getFieldType().subscribe((res: any) => {
      this.fieldTypeList = res.data;
    })
  }

  searchField: any = '';
  availableFields = [
    { icon: 'text', text: 'text', description: 'Type in a single line of text like a name or note', type: "text", customIcon: true, iconTxt: 'A|' },
    { icon: 'textArea', text: 'text area', description: 'Get a text area with full width', type: "desc", customIcon: true, iconTxt: '#|' },
    { icon: 'number', text: 'number', description: 'Type in a number without decimals or fractions', type: "number", customIcon: true, iconTxt: '#|' },
    { icon: 'money', text: 'money', description: 'Type in a monetary value, with currency', type: "money", customIcon: true, iconTxt: '₹|' },
    { icon: 'calendar_today', text: 'date', description: 'select a day of the year from the  calender', type: "date", customIcon: false, iconTxt: null },
    { icon: 'check_circle_outline', text: 'checkbox', description: 'One or more yes or no choices', type: "checkbox", customIcon: false, iconTxt: null },
    { icon: 'format_list_bulleted', text: 'dropdown', description: 'Select a single choice from a menu of options you define', type: "dropdown", customIcon: false, iconTxt: null },
    { icon: 'star_border', text: 'rating', description: 'An input for a rating from 1 to 5 starts', type: "rating", customIcon: false, iconTxt: null },
    { icon: 'radio_button_checked', text: 'Radio Button', description: 'One or more yes or no choices', type: "radioButton", customIcon: false, iconTxt: null },
  ];

  screen: "SELECT_FIELDS" | "ADD_FIELDS" | "EDIT_FIELD" = "SELECT_FIELDS";
  public selectedInputType: INPUT_FIELDS_TYPE | null = "text";
  public newFieldLabel: string = "";
  addedField: Field[] = [];
  customAddedFields: any[] = [];

  // fieldOptions: { label: string, value: string }[] = [{ label: '', value: '' }];
  // optionsCount: number = 2;
  // fieldsdata: any;
  payload: any = {
    fieldId: this.data?.data?.fieldId,
    businessId: this.dbService.getBusinessId(),
    fieldLabel: this.data?.data?.fieldLabel,
    dataType: this.selectedInputType,
    showInEnquiry: this.data?.data?.showInEnquiry ?? false,
    showInRegistration: this.data?.data?.showInRegistration,
    showInAdmission: this.data?.data?.showInAdmission,
    hint: this.data?.data?.hint,
    errorMessage: this.data?.data?.errorMessage,
    minLimit: this.data?.data?.minLimit,
    maxLimit: this.data?.data?.maxLimit,
    status: true,
    dataFieldConstraints: [],
    selected: true,
    default: true,
    fieldGroup: [],
    required: this.data?.data?.required,
    filterable: this.data?.data?.filterable,
    searchable: this.data?.data?.searchable,
    dataSourceType: null,
    value: null,
    type: null,
    multipleSelection: false,
    hideInBulkUpload : false
  }

  srcHeight: any;
  screenWidth: any;

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.srcHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  selectedfieldgroupId: any;

  ngOnInit() {
    if (this.data.edit === true) {
      this.selectedFieldGroups = this.data.data.fieldGroup

      //;
      this.payload = this.data.data;
      this.selectedInputType = this.data.selectedInputType.toLowerCase();
      this.payload.fieldGroup = this.data.data.fieldGroup || [];
      // this.selectedFieldGroups = this.payload.fieldgroup.map((group)=> {
      
      //   return this.fieldGroups.find((fg)=> fg.fieldGroupId === group.fieldGroupId);
      // });
      this.payload.dataFieldConstraints = this.data.data.dataFieldConstraints || [];
      this.selectedValidations = this.payload.dataFieldConstraints.map((constraint) => {
        return this.validationList.find((validation) =>
          validation.id === constraint.id);
      });
      if(this.data?.data?.dataSourceType){
        this.selectedSourceOption = "Masters";
    } else {
      this.selectedSourceOption = "Custom Options";
    }
    if(this.data?.data?.value){
    this.fieldOptions = [];
  
      this.data.data.value.forEach((data) => {
        this.fieldOptions.push({
          label: data.label,
          value: data.value
        })
      });
  
      // this.optionsCount = this.fieldOptions.length;
    }
    }

    this.fieldCategory = this.data?.fieldCategory ? this.data.fieldCategory : "ENQUIRY";
    this.screen = this.data.screen
    if(this.data.screen === 'CUSTOM_FORM'){
      this.screen = 'ADD_FIELDS'
      this.selectedSourceOption = 'Custom Options'
    }
    if (this.data?.data) {
      this.addedField = this.data.data;
    }
    if (this.bottomData?.data) {
      this.addedField = this.bottomData.data;
    }
    this.addCustomFields();
    this.screenSize();
    this.getFieldsApi();
  }

  @HostListener('window: resize')
  screenSize() {
    this.screenWidth = window.innerWidth
  }

  get getInputType(): string {
    return this.selectedInputType as unknown as string;
  }
  // get canAddMoreOption(): boolean {
  //   return this.fieldOptions.every((field) => field.value?.length > 0);
  // }

  pageLoader: boolean = false;
  pageNo: number = 0;
  size: number = 10;
  status = true;
  showfields: any;
  responseData: any = [];
  dataSource: any = []
  fieldGroups: any = []

  selectedFieldGroups: any = [];
  tempCreatedGroup: any;

  opencreategroup() {
    let dialog = this.dialog.open(CreateFieldGroupComponent, {
      height: '100vh',
      width: '35%',
      position: { top: '0', right: '0' }
    })

    dialog.afterClosed().subscribe((res) => {
      if (res != null && res.data != null) {
        this.tempCreatedGroup = res.data;
        this.getFieldGroupList();
      }
    });
  }

  selectedValidations: { id: number; name: string }[] = [];
  updateDataFieldConstraints(): void {
    this.payload.dataFieldConstraints = [];

    this.selectedValidations.forEach((validation: { id: number; name: string }) => {
      // this.payload.dataFieldConstraints[validation.id] = validation.name;

      this.payload.dataFieldConstraints.push({
        id: validation.id,
        name: validation.name
      })
    });

    if (this.data.edit == true) {
      this.payload.dataFieldConstraints = this.data.data.dataFieldConstraints
    }

  }

  selected = new FormControl('valid', [Validators.required, Validators.pattern('valid')]);

  selectFormControl = new FormControl('valid', [Validators.required, Validators.pattern('valid')]);

  nativeSelectFormControl = new FormControl('valid', [
    Validators.required,
    Validators.pattern('valid'),
  ]);

  validationList = [{ "id": 1, "name": "Uppercase" }, { "id": 2, "name": "Lowercase" }, { "id": 3, "name": "Numbers(1, 2, ..)" }, { "id": 4, "name": "Special characters (@,#,..)" }];


  selectedSourceOption: string = 'Masters'; // Default value
  dataSourceTypes: string[] = []; // Dynamic list of strings
  selectedSourceItem: string = '';

  onSelectionChange(event: any): void {
    this.selectedSourceOption = event.value;
    // Additional logic can go here
  }

  getFieldsApi() {
    this.pageLoader = true;
    this.payload.dataFieldConstraints = [];
    this.crmService.getAllCustomFields(this.dbService.getBusinessId(), '').subscribe(
      {
        next: (value: any) => {
          const rawFields: any[] = value?.data?.data || [];
          const uniqueMap = new Map<string, any>();

          rawFields.forEach((element: any) => {
            if (element && element.fieldLabel) {
              const key = element.fieldLabel.toLowerCase().trim();
              if (!uniqueMap.has(key)) {
                uniqueMap.set(key, element);
              } else {
                const existing = uniqueMap.get(key);
                const isItemActive = element.showInForm && element.showInForm.includes('ENQUIRY');
                const isExistingActive = existing.showInForm && existing.showInForm.includes('ENQUIRY');
                if (isItemActive && !isExistingActive) {
                  uniqueMap.set(key, element);
                }
              }
            }
          });

          const deduplicated = Array.from(uniqueMap.values());
          this.responseData = deduplicated;
          this.dataSource = deduplicated;
          this.pageLoader = false;
          this.addCustomFields();
        },
        error: (err: any) => {
          this.crmService.openSnack(err?.error?.message || "Error loading fields", "Close");
          this.pageLoader = false;
        },
      }
    );
  }

  getDataSourceTypesApi() {
    this.crmService.getDataSourceTypesApi().subscribe(
      {
        next: (value: any) => {
          this.dataSourceTypes = this.removeUnderscores(value.data);
          if (this.data.edit == true) {
            if(this.data.data.dataSourceType){
              for(let i = 0; i < this.dataSourceTypes.length; i++) {
                if (this.dataSourceTypes[i] === this.data.data.dataSourceType.split('_').join(' ')) {
                  this.selectedSourceItem = this.dataSourceTypes[i];
                  break;
                }
              }
            }
          }
        },
        error: (err: any) => {
          this.crmService.openSnack(err.error.message, "Close");
        },
      }
    );
  }

  removeUnderscores(list: string[]): string[] {
    return list.map(item => item.replace(/_/g, ' '));
  }

  private addCustomFields() {
    if (!this.addedField || !Array.isArray(this.addedField)) {
      this.customAddedFields = [];
      return;
    }
    this.customAddedFields = this.addedField.filter((field) => {
      if (!Object.hasOwn(field, 'status')) return false;
      const existsInDataSource = this.dataSource && this.dataSource.some((ds: any) => 
        ds.fieldLabel && field.label && ds.fieldLabel.toLowerCase().trim() === field.label.toLowerCase().trim()
      );
      return !existsInDataSource;
    });
  }

  closeModal() {
    if (this.screenWidth > 475) {
      this.dialogRef.close()
    }
    if (this.screenWidth < 475) {
      this.dialogRef.close()
    }
  }

  changeTextField(field: any, type: 'CHECK' | 'REQUIRED') {
    if (type == 'REQUIRED')
      field.status = true;
    let index = -1;
    for (let i = 0; i < this.addedField.length; i++) {
      if (this.addedField[i].label === field.label) {
        this.addedField[i].required = (field.required && type == 'REQUIRED');
        index = i;
        break;
      }
    }

    if (index == -1) {

      this.addedField.push({
        label: field.label,
        value: field.value,
        type: field.type,
        required: field.required,
        options: field.options,
      })
    } else if (type == 'CHECK') {

      if (Object.hasOwn(field, "status"))
        field.status = false
      else
        this.addedField.splice(index, 1);
    }
  }

  public addNewInput(field) {
    this.selectedInputType = field.type;
    if(this.data.screen === 'CUSTOM_FORM'){
      this.payload.dataType = field.type
    }
    this.screen = "EDIT_FIELD";
  }
  public cancelEdit() {
    this.screen = "ADD_FIELDS";
    this.newFieldLabel = ""; 1
  }
  public cancelfromlistedit() {
    this.dialogRef.close()
  }
  isFiledOptionEmpty: boolean = false;
  public saveEdit() {
    if((this.selectedFieldGroups?.length ?? 0) == 0){
      this.crmService.openSnack("Field group is required.", "Close");
      return;
    }

    if(window.location.pathname.includes('list-fields')){
      this.payload.showInEnquiry = this.payload.showInEnquiry ?? false;
      this.addCustomFieldToList();
    }
    else{
      this.payload.showInEnquiry = true;
      this.addCustomFieldToList();
    }
  }


  addCustomFieldToList(){
    if (!this.isFormValid()) {
      this.crmService.openSnack("Field Label is required.", "Close");
      return;
    }
    this.payload.fieldGroup = [];
    if (this.fieldGroups != null && this.selectedFieldGroups != null) {
      this.fieldGroups.forEach(group => {
        this.selectedFieldGroups.forEach(selectedFG => {
          if (selectedFG.fieldGroupId === group.fieldGroupId) {
            const isDuplicate = this.payload.fieldGroup.some(
              (item) => item.fieldGroupId === group.fieldGroupId
            );
            if (!isDuplicate) {
              this.payload.fieldGroup.push({
                fieldGroupId: group.fieldGroupId,
                fieldGroupName: group.fieldGroupName,
                fieldStepId: group.fieldParentGroup ? group.fieldParentGroup.id : null,
                fieldStepName: group.fieldParentGroup ? group.fieldParentGroup.name : null,
              });
            }
          }
        });
      });
    }
    

    if ((this.selectedInputType == "checkbox" || this.selectedInputType == "dropdown") && this.selectedSourceOption === "Masters") {
      if (this.selectedSourceItem == null || this.selectedSourceItem == "") {
        this.crmService.openSnack("Please Select Source Item", "Close");
        return;
      }
    }

    if(this.data.screen === 'CUSTOM_FORM'){
      this.payload.showInEnquiry = false
      this.payload.value = this.fieldOptions
      this.dialogRef.close(this.payload)
      return;
    }

    this.payload.dataType = this.selectedInputType?.toUpperCase() as INPUT_FIELDS_TYPE;
    if ((this.selectedInputType == "checkbox" || this.selectedInputType == "dropdown") && this.selectedSourceOption === "Masters") {
      this.payload.dataSourceType = (this.selectedSourceItem.split(' ').join('_')).toUpperCase();
    }

    if (this.fieldOptions != null && this.fieldOptions.length > 0 && this.selectedSourceOption === "Custom Options") {
      this.isFiledOptionEmpty = this.fieldOptions[0].label === ""; // Check the first field option

      if (!this.isFiledOptionEmpty) {
        this.payload.value = this.fieldOptions; // Only set payload if the first label is not empty
      }
    }
    if (this.data.edit === true) {

    } else {
      this.crmService.createfields(this.payload, this.fieldCategory).subscribe(
        (res: any) => {
          if(window.location.pathname.includes('list-fields')){
            this.crmService.openSnack("Field created successfully", "Close");
            this.getFieldsApi();
          }
          if(window.location.pathname.includes('enquiry-form')){
            this.crmService.createFieldInForms.emit({createFrom:"ENQUIRY_FORM"});
          }
          if(window.location.pathname.includes('website-editor')){
            this.crmService.createFieldInForms.emit({createFrom:'WEBSITE_EDITOR'})
          }
          this.dialogRef.close()
          this.payload = res.data;
        },
        (err) => {
          this.crmService.openSnack(
            err.error.message,
            'Close'
          )
        }
      )

    }

    if (this.screen == "EDIT_FIELD") {
      this.crmService.updatefields(this.payload, this.fieldCategory).subscribe((res: any) => {
        this.payload = res.data;
        this.payload.showInEnquiry = res.data.showInEnquiry;
        this.payload.showInRegistration = res.data.showInRegistration;
        this.payload.showInAdmission = res.data.showInAdmission;
        // this.payload.fieldGroup = this.selectedFieldGroups
        //;
        this.crmService.openSnack("Field updated successfully", "Close");
        this.dialogRef.close();
      })
    } else {
      if (!this.selectedInputType)
        return;
      this.addedField.push({
        label: this.newFieldLabel = this.payload.fieldLabel,
        value: this.newFieldLabel,
        type: this.selectedInputType,
        required: false,
        status: true,
        options: (this.selectedInputType == "checkbox" || this.selectedInputType == "dropdown") ? this.fieldOptions.filter((option) => option.value.length > 0) : [],
      });
      this.customAddedFields.push({
        label: this.newFieldLabel,
        value: this.newFieldLabel,
        type: this.selectedInputType,
        required: false,
        options: (this.selectedInputType == "checkbox" || this.selectedInputType == "dropdown") ? this.fieldOptions.filter((option) => option.value.length > 0) : [],
        status: true,
      });
      this.newFieldLabel = "";
      this.screen = "SELECT_FIELDS";
    }

  }

  prepareFieldGroupData() {
    //;
    this.payload.fieldGroup = [];
    if (this.fieldGroups != null && this.selectedFieldGroups != null) {
      this.fieldGroups.forEach(fieldGroup => {
        if (this.selectedFieldGroups.includes(fieldGroup.fieldGroupId)) {
          this.payload.fieldGroup.push({
            id: fieldGroup.fieldGroupId,
            name: fieldGroup.fieldGroupName
          })
        }
      });
    }
  }


  getFieldGroupList() {
    this.pageLoader = true;
    this.crmService.getFieldGroupApi(this.dbService.getBusinessId()).subscribe(
      {
        next: (value: any) => {
          
          this.fieldGroups = value.data.data.filter((ele)=>{
            return ele.status
          });
          this.pageLoader = false;
          // //;
          if (this.tempCreatedGroup != null) {
            this.fieldGroups.forEach(element => {
              if (this.tempCreatedGroup.fieldGroupId === element.fieldGroupId) {
                this.selectedFieldGroups = element
              }
            });
          } else if (this.data.edit === true) {
            if (this.fieldGroups != null && this.fieldGroups.length > 0) {
              this.fieldGroups.forEach(element => {
                if (this.payload.fieldGroup != null && this.payload.fieldGroup.length > 0) {
                  this.payload.fieldGroup.forEach(fieldGroup => {
                    if (fieldGroup.fieldGroupId === element.fieldGroupId) {
                      this.selectedFieldGroups.push(element);
                    }
                  });
                }

              });
            }
          } else {
            this.selectedFieldGroups = this.fieldGroups.filter(
              (group: any) => group.fieldGroupName === 'Miscellaneous'
            );
          }
        },
        error: (err: any) => {
          this.crmService.openSnack(err.error.message, "Close");
        },
      }
    )
  }

  fieldOptions: { label: string, value: string }[] = [
    { label: '', value: '' },
    { label: '', value: '' }
  ];

  get optionsCount(): number {
    return this.fieldOptions.length;
  }

  get canAddMoreOption(): boolean {
    return this.fieldOptions.length >= 2 && 
    this.fieldOptions.every((field) => field.value?.trim().length > 0);
  }

  onOptionValueChange(index: number, value: string): void {
    this.fieldOptions[index].value = value;
    this.fieldOptions[index].label = value;
  }
  removeOption(idx: number): void {
    if (this.fieldOptions.length <= 2) {
      return;
    }
    this.fieldOptions = this.fieldOptions.filter((_, index: number) => idx !== index);
  }

  addMoreOption(): void {
    if (!this.canAddMoreOption) {
      return;
    }
    
    this.fieldOptions.push({ label: '', value: '' });
  }

  isValueConflict(idx: number): boolean {
    const currentValue = this.fieldOptions[idx].value?.trim().toLowerCase();
    
    if (!currentValue) {
      return false;
    }
    
    const occurrences = this.fieldOptions.filter(
      (option, index) => 
        option.value?.trim().toLowerCase() === currentValue && 
        index !== idx
    ).length;
    
    return occurrences > 0;
  }

  getOptionValues(): string[] {
    return this.fieldOptions.map(option => option.value.trim()).filter(value => value.length > 0);
  }
  editInput(field) {
    this.screen = "EDIT_FIELD";
    this.selectedInputType = field.type;
    this.newFieldLabel = field.value;
    // this.optionsCount = field.options.length;
    this.fieldOptions = field.options;
  }
  deleteInput(field) {
    this.addedField = this.addedField.filter((f) => f.value != field.value);
    this.customAddedFields = this.customAddedFields.filter((f) => field.value != f.value);
  }
  drop(event: CdkDragDrop<unknown>) {
    moveItemInArray(this.customAddedFields, event.previousIndex, event.currentIndex);
  }

  showInEnquiry: boolean = false;

  onCheckboxChange() {
  }


  showEditor: boolean = false;
  multiTabEditor: boolean = false;

  dismiss() {
    this.showEditor = false;
    this.multiTabEditor = false;

    this.dialogRef.close();

  }

  isFormValid(): boolean {
    if (!this.payload.fieldLabel || !this.payload.fieldLabel.trim()) {
      return false;
    }
    if (
      (this.selectedInputType === 'checkbox' ||
        this.selectedInputType === 'dropdown' ||
        this.selectedInputType === 'radioButton') &&
      this.selectedSourceOption === 'Custom Options'
    ) {
      const hasEmpty = this.fieldOptions.some(
        opt => !opt.value || !opt.value.trim()
      );
      if (hasEmpty) return false;
      const values = this.fieldOptions
        .map(o => o.value.trim());

      if (new Set(values).size !== values.length) return false;
    }
    return true;
  }

  searchListField() {
    this.crmService.getAllCustomFields(this.dbService.getBusinessId(), this.searchField).subscribe(
      (res: any) => {
        this.responseData = res.data.data
        this.dataSource = res.data.data
      },
      (err) => {
        this.crmService.openSnack(
          `${err.error.message}`,
          'Close'
        )
      }
    )
  }

  updateItem(event: any, item: any) {
    const isChecked = event?.checked !== undefined ? event.checked : (event?.target?.checked !== undefined ? event.target.checked : false);
    this.crmService.addOrRemoveItemFromWebForm.emit({ updateItem: true, status: isChecked, value: item });
  }

  upadteIsRequired(ev: any, item: any) {
    const isChecked = ev?.checked !== undefined ? ev.checked : (ev?.target?.checked !== undefined ? ev.target.checked : false);
    this.crmService.updateIsRequiredInWebForm.emit({ isRequered: true, status: isChecked, value: item });
  }

}
